import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

import { af, bareButtonCss, compactQuery, floatingSurfaceCss, hoverQuery, selectedRingCss } from '../theme';

const styles = {
  root: css`
    ${bareButtonCss};
    ${floatingSurfaceCss};
    display: flex;
    /*
     * Centred, not flex-start: with flex-start the min-height dumps its slack at the
     * bottom and rows sit visibly misaligned.
     */
    align-items: center;
    gap: ${af.sp3};
    width: 100%;
    min-height: 60px;
    padding: ${af.sp4} ${af.sp5};
    text-align: left;
    transition: box-shadow 0.12s ease;

    ${compactQuery} {
      padding: ${af.sp3} ${af.sp4};
    }

    /*
     * Hover darkens the edge without moving anything. The shipped stylesheet still
     * carries a border-color hover from before surfaces moved onto shadow, where it no
     * longer resolves to anything; this is that intent, expressed on the shadow.
     *
     * Pointer devices only: on touch the state would stick to the tapped answer.
     */
    ${hoverQuery} {
      &:hover:not([aria-checked='true']) {
        box-shadow:
          ${af.shadowCard},
          inset 0 0 0 1px ${af.line};
      }
    }
  `,

  selected: css`
    ${selectedRingCss};

    ${hoverQuery} {
      &:hover {
        ${selectedRingCss};
      }
    }
  `,

  radio: css`
    flex: 0 0 20px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1.5px solid ${af.line};
    background: ${af.paper};
    position: relative;
  `,

  /** Fills ink with a punched paper dot. */
  radioSelected: css`
    border-color: ${af.ink};
    background: ${af.ink};

    &::after {
      content: '';
      position: absolute;
      inset: 4px;
      border-radius: 50%;
      background: ${af.paper};
    }
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
